import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issuesShipped: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped',
		defaultMessage:
			'{issueCount} {issueCount, plural, one {issue} other {issues}} shipped to production',
		description: 'Number of Jira issues that are associated with the deployment being shown.',
	},
	issuesShippedIssueTermRefresh: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-issue-term-refresh',
		defaultMessage:
			'{issueCount} {issueCount, plural, one {work item} other {work items}} shipped to production',
		description: 'Number of Jira issues that are associated with the deployment being shown.',
	},
	issuesShippedLimitedPermissions: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-limited-permissions',
		defaultMessage:
			'Showing {issueCount} {issueCount, plural, one {issue} other {issues}} shipped to production',
		description:
			'Number of Jira issues that are associated with the deployment being shown. User does not have permission to see some of the issues.',
	},
	issuesShippedLimitedPermissionsIssueTermRefresh: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-limited-permissions-issue-term-refresh',
		defaultMessage:
			'Showing {issueCount} {issueCount, plural, one {work item} other {work items}} shipped to production',
		description:
			'Number of Jira issues that are associated with the deployment being shown. User does not have permission to see some of the issues.',
	},
	issuesShippedLimitedPermissionsTooltip: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-limited-permissions-tooltip',
		defaultMessage:
			'You are viewing the issues based on the permissions. Contact admin for details.',
		description: 'Tooltip explaining why not all issues are shown in the table.',
	},
	issuesShippedLimitedPermissionsTooltipIssueTermRefresh: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-limited-permissions-tooltip-issue-term-refresh',
		defaultMessage:
			'You are viewing the work items based on the permissions. Contact admin for details.',
		description: 'Tooltip explaining why not all issues are shown in the table.',
	},
});
